import { render, staticRenderFns } from "./VerbalProcessProviders.vue?vue&type=template&id=3ad5cc87"
import script from "./VerbalProcessProviders.vue?vue&type=script&lang=js"
export * from "./VerbalProcessProviders.vue?vue&type=script&lang=js"
import style0 from "./VerbalProcessProviders.vue?vue&type=style&index=0&id=3ad5cc87&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports